<template>
    <div class="family-layout hero is-large">
        <div class="hero-body">
            <div class="container has-text-centered">
                <div class="column is-12">
                    <router-view></router-view>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'FamilyLayout',
};
</script>
<style scoped>
::v-deep html {
    background-color: #f8f8f8 !important;
}

@media screen and (min-width: 1024px), print {
    .hero-body {
        padding: 10rem 1.5rem !important;
    }
}
</style>
